import { Notyf } from "notyf";
import { useContext } from "react";
import NotyfContext from "../utils/notyf";

const useNotyf = (): Notyf => useContext(NotyfContext);

export default useNotyf;
